// Fixed local document: the visited site is only a JPEG here. No site HTML,
// cookies, credentials or network access enter this WebView.
export const MAC_BROWSER_CANVAS_HTML = `<!doctype html><html><head><meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src data:; style-src 'unsafe-inline'; script-src 'unsafe-inline'; connect-src 'none'; form-action 'none'">
<style>html,body{margin:0;width:100%;height:100%;overflow:hidden;background:#111}#stage{width:100%;height:100%;display:flex;align-items:center;justify-content:center;outline:0}#frame{max-width:100%;max-height:100%;object-fit:contain;user-select:none;-webkit-user-drag:none}#input{position:fixed;left:0;bottom:0;width:1px;height:1px;opacity:0;resize:none}</style></head>
<body><div id="stage" role="application" aria-label="Cloud browser viewport"><img id="frame" alt="Cloud browser"></div><textarea id="input" aria-label="Type into cloud browser" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"></textarea>
<script>(function(){
  const stage=document.getElementById('stage'), frame=document.getElementById('frame'), input=document.getElementById('input');
  let control=false, down=false, composing=false, lastPoint=null;
  const send=m=>{if(control)window.ReactNativeWebView.postMessage(JSON.stringify(m));};
  const point=(e,clamp=false)=>{
    const r=frame.getBoundingClientRect();if(!r.width||!r.height||!frame.src)return null;
    if(!clamp&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))return null;
    return {x:Math.max(0,Math.min(1,(e.clientX-r.left)/r.width))*1280,y:Math.max(0,Math.min(1,(e.clientY-r.top)/r.height))*800};
  };
  window.gabBrowserFrame=(data,enabled)=>{
    if(data)frame.src='data:image/jpeg;base64,'+data;
    control=enabled===true;input.disabled=!control;if(!control){down=false;input.value='';input.blur();}
  };
  const mouse=(e,action)=>{
    if(!control)return;const p=point(e,action==='up'&&down);if(!p)return;
    if(action==='down'){e.preventDefault();input.focus({preventScroll:true});down=true;}
    if(action==='up')down=false;lastPoint=p;
    send({kind:'mouse',action,button:['left','middle','right'][e.button]||'left',...p});
  };
  stage.addEventListener('mousedown',e=>mouse(e,'down'));
  document.addEventListener('mouseup',e=>mouse(e,'up'));
  stage.addEventListener('mousemove',e=>mouse(e,'move'));
  stage.addEventListener('dblclick',e=>mouse(e,'dblclick'));
  stage.addEventListener('contextmenu',e=>e.preventDefault());
  stage.addEventListener('wheel',e=>{if(!control)return;const p=point(e);if(!p)return;e.preventDefault();send({kind:'scroll',...p,deltaX:e.deltaX,deltaY:e.deltaY});},{passive:false});
  input.addEventListener('keydown',e=>{
    if(!control||e.isComposing)return;
    if((e.metaKey||e.ctrlKey)&&e.key.toLowerCase()==='v')return;
    if((e.metaKey||e.ctrlKey)&&e.key.toLowerCase()==='a'){
      e.preventDefault();send({kind:'key',key:'a',action:'press',modifiers:2});return;
    }
    if(e.metaKey||e.ctrlKey||e.altKey)return;
    if(['Enter','Tab','Backspace','Delete','Escape','ArrowLeft','ArrowUp','ArrowRight','ArrowDown','Home','End','PageUp','PageDown'].includes(e.key)){
      e.preventDefault();e.stopPropagation();send({kind:'key',key:e.key,action:'press',modifiers:e.shiftKey?8:0});
    }
  });
  const text=value=>{
    if(value.length>16384)send({kind:'input_error',reason:'paste-too-long'});
    else if(value)send({kind:'text',text:value});input.value='';
  };
  input.addEventListener('compositionstart',()=>{composing=true;});
  input.addEventListener('compositionend',()=>{composing=false;text(input.value);});
  input.addEventListener('input',()=>{if(!composing)text(input.value);});
  input.addEventListener('paste',e=>{if(!control)return;e.preventDefault();text(e.clipboardData.getData('text/plain'));});
  window.addEventListener('blur',()=>{if(down&&lastPoint)send({kind:'mouse',action:'up',button:'left',...lastPoint});down=false;input.value='';});
  window.ReactNativeWebView.postMessage(JSON.stringify({kind:'ready'}));
})();</script></body></html>`;

// Defense at the native message boundary; only the established input protocol
// reaches the authenticated socket. Never copy these values into diagnostics.
export function macBrowserInput(raw) {
  if (typeof raw !== 'string' || raw.length > 70000) return null;
  let value;
  try { value = JSON.parse(raw); } catch { return null; }
  const point = () => Number.isFinite(value.x) && value.x >= 0 && value.x <= 1280 && Number.isFinite(value.y) && value.y >= 0 && value.y <= 800;
  if (value?.kind === 'ready') return { kind: 'ready' };
  if (value?.kind === 'input_error' && value.reason === 'paste-too-long') return { kind: 'input_error', reason: value.reason };
  if (value?.kind === 'text' && typeof value.text === 'string' && value.text.length <= 16384) return { kind: 'text', text: value.text };
  if (value?.kind === 'key' && value.key === 'a' && value.modifiers === 2) return { kind: 'key', key: 'a', action: 'press', modifiers: 2 };
  if (value?.kind === 'key' && ['Enter', 'Tab', 'Backspace', 'Delete', 'Escape', 'ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown'].includes(value.key))
    return { kind: 'key', key: value.key, action: 'press', modifiers: value.modifiers === 8 ? 8 : 0 };
  if (value?.kind === 'mouse' && point() && ['down', 'up', 'move', 'dblclick'].includes(value.action) && ['left', 'middle', 'right'].includes(value.button))
    return { kind: 'mouse', action: value.action, button: value.button, x: value.x, y: value.y };
  if (value?.kind === 'scroll' && point() && Number.isFinite(value.deltaX) && Number.isFinite(value.deltaY))
    return { kind: 'scroll', x: value.x, y: value.y, deltaX: Math.max(-10000, Math.min(10000, value.deltaX)), deltaY: Math.max(-10000, Math.min(10000, value.deltaY)) };
  return null;
}
